<template>
  <div class="action-config-item">
    <div class="mb-4">
      <label for="action-name" class="block text-sm font-semibold text-gray-700">Action Name</label>
      <el-input
        v-model="localStep.label"
        id="action-name"
        placeholder="Enter Action Name"
        clearable
        class="w-full rounded-md"
      />
    </div>
    <el-button class="email-config-button" @click="openWorkflowConfiguration()">
      <i style="color: #409eff" class="el-icon-setting">Configure</i>
    </el-button>
    <!-- Footer Actions -->
    <div class="automation-footer-actions mt-4 flex justify-end gap-2">
      <el-button @click="cancelChanges">Cancel</el-button>
      <el-button type="primary" @click="saveChanges">Save</el-button>
    </div>
    <dialog-component
      :title="'Configure Workflow Data'"
      :visible="openWorkflowConfiguringDialog"
      @before-close="resetWorkflowConfigureDialog"
      :containerWidth="'49%'"
    >
      <div v-if="mapFieldsToDocTemplateModel">
        <el-table :data="tableData" size="mini" border v-loading="loading" style="width: 100%">
          <el-table-column label="Field" prop="label" width="200">
            <template slot-scope="{ row }">
              <div style="font-weight: 500; font-size: 12px; color: #030503">
                {{ row.label }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Mapped with" prop="key" width="250">
            <template slot-scope="scope">
              <div class="d-flex">
                <el-select
                  multiple
                  filterable
                  v-if="workflow_configuration[0].fieldsMappedData"
                  v-model="
                    workflow_configuration[0].fieldsMappedData[
                      'mapped/' + scope.row._id + '#' + scope.row.key
                    ]
                  "
                >
                  {{ scope.row._id }} {{ scope.row.key }}
                  <el-option
                    v-for="(field, i) in wfelements"
                    :key="field.key + i"
                    :value="field.key"
                    :label="field.label + ' - Template Name:-' + field.doc_name"
                  ></el-option>
                </el-select>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="custom-card mt-1 mb-1">
        <template v-if="workflow_configuration.length && !mapFieldsToDocTemplateModel">
          <div v-for="(temp, index) in workflow_configuration" :key="index" class="d-flex">
            <el-tooltip content="Select Workflow." placement="top">
              <el-select
                class="mb-1 mt-1 fw-400 w-100"
                placeholder="Select Workflow"
                v-model="temp.workflow_id"
                @change="handleWorkflowsChange"
                clearable
              >
                <el-option
                  v-for="(doctemp, index) in workflowsConfigData"
                  :key="index + '_' + doctemp.id"
                  :label="doctemp.name"
                  :value="doctemp.id"
                ></el-option>
              </el-select>
            </el-tooltip>
            <el-tooltip
              content="Map current entity field values to the selected document template fields in workflow"
              placement="top"
            >
              <el-button @click="openWorkflowMappingDialog(temp, index)" type="text" class="ml-1">
                Map values
                <i class="el-icon-info"></i>
              </el-button>
            </el-tooltip>
            <el-tooltip content="The action-triggered user will be the sender." placement="top">
              <el-checkbox
                type="text"
                class="ml-1 checkbox-center-right"
                v-model="temp.is_Action_Triggered_User_As_Sender"
              >
                Update Action User As Sender
                <i class="el-icon-info"></i>
              </el-checkbox>
            </el-tooltip>
            <el-tooltip
              content="eSign settings are not enabled for this application user. To send completion emails to both sender and receiver, please enable eSign settings."
              placement="top"
              v-if="temp.is_Action_Triggered_User_As_Sender"
            >
              <i
                class="el-icon-setting checkbox-center-right"
                style="float: right"
                @click="openSenderSettingsModal = true"
              ></i>
            </el-tooltip>
            <dialog-component
              title="Configure Settings For Application User"
              :visible="openSenderSettingsModal"
              @before-close="openSenderSettingsModal = false"
              :containerWidth="'49%'"
              v-if="temp.is_Action_Triggered_User_As_Sender"
            >
              <template>
                <div class="action-settings">
                  <strong class="heading">
                    Configure the settings for the action-triggered user:
                  </strong>

                  <div class="setting-option">
                    <el-checkbox v-model="temp.is_recipient_signs_notify">
                      Send completion email to user
                    </el-checkbox>
                    <el-tooltip
                      content="Enable this option to send a completion email to the user once the document is completed."
                      placement="top"
                    >
                      <i class="el-icon-info info-icon"></i>
                    </el-tooltip>
                  </div>
                  <div class="setting-option">
                    <el-checkbox v-model="temp.is_user_opens_notify">
                      Send notification when user opens the document to sender.
                    </el-checkbox>
                    <el-tooltip
                      content="Enable this option to send an email to the sender if receiver open/view the document."
                      placement="top"
                    >
                      <i class="el-icon-info info-icon"></i>
                    </el-tooltip>
                  </div>
                  <div class="setting-option">
                    <el-checkbox v-model="temp.attach_pdf">
                      Attach PDF to completion email
                    </el-checkbox>
                    <el-tooltip
                      content="Enable this option to attach the PDF to the completion email sent to the user."
                      placement="top"
                    >
                      <i class="el-icon-info info-icon"></i>
                    </el-tooltip>
                  </div>
                </div>
              </template>
              <span slot="footer" class="dialog-footer">
                <el-button type="plain" @click="openSenderSettingsModal = false">Close</el-button>
                <el-button type="primary" @click="openSenderSettingsModal = false">
                  Save Settings
                </el-button>
              </span>
            </dialog-component>
          </div>
        </template>
      </div>
      <div v-for="(temp, index) in workflow_configuration" :key="index">
        <div v-if="temp.workflow_id && !mapFieldsToDocTemplateModel">
          <el-row
            class="custom-card mt-1"
            v-for="(user, userIndex) in temp.selected_users"
            :key="userIndex"
            :gutter="10"
          >
            <span v-if="user.user_type !== 'SENDER'" class="number-highlight">
              {{ userIndex + 1 + '.' }}
            </span>

            <el-tooltip effect="dark" content="Is primary user?" placement="top-start">
              <el-checkbox
                v-model="user.is_primary_user"
                :disabled="
                  temp.selected_users.some((u) => u.is_primary_user) && !user.is_primary_user
                "
              ></el-checkbox>
            </el-tooltip>
            <el-col :span="8">
              <el-input
                v-if="user.type === 'SENDER'"
                v-model="user.email"
                :disabled="true"
              ></el-input>
              <el-select
                :disabled="true"
                v-model="user.email"
                placeholder="Contact Details - email"
                v-if="user?.contact_type === entityIDForDocTemp && user.type !== 'SENDER'"
              >
                <el-option :label="'Contact Details - email'" :value="user.email"></el-option>
              </el-select>
              <el-select
                v-if="user.type !== 'SENDER' && user?.contact_type !== entityIDForDocTemp"
                v-model="user.contact_id"
                placeholder="Send to"
                @change="(changedValue) => getEntityDetails(entityIDForDocTemp, localStep)"
                clearable
                filterable
              >
                <el-option-group label="Entity fields">
                  <el-option
                    v-for="(field, i) in getUserEntities(
                      getFieldsByType(['ENTITY'], allFieldsWithDataTable)
                    )"
                    :key="field.entity_id + '#' + i"
                    :value="field.key + '#' + user.name + '#' + user.contact_type"
                    :label="field.label"
                  />
                </el-option-group>
              </el-select>
            </el-col>
            <el-col :span="8">
              <el-input :disabled="true" v-model="user.name"></el-input>
            </el-col>
            <el-col :span="8">
              <el-input :disabled="true" v-model="user.user_type"></el-input>
            </el-col>
          </el-row>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          v-if="!mapFieldsToDocTemplateModel"
          type="plain"
          @click="resetWorkflowConfigureDialog"
        >
          Close
        </el-button>
        <el-button
          v-if="mapFieldsToDocTemplateModel"
          type="plain"
          @click="resetMappingDocumentTemplateDialog"
        >
          Back To User Configuration
        </el-button>
        <el-button
          type="primary"
          :disabled="!workflow_configuration[0].workflow_id"
          @click="saveWorkflowConfiguration"
        >
          Save Configuration
        </el-button>
      </span>
    </dialog-component>
  </div>
</template>

<script>
  import { postAPICall } from '../../../../helpers/httpHelper';
  import StepEditableMixin from './StepEditableMixin';
  export default {
    name: 'SendWorkflowAction',
    props: {
      step: Object,
      currentEntity: Object,
    },
    mixins: [StepEditableMixin],
    data() {
      return {
        loading: false,
        workflowsConfigData: [],
        selectedWorkflow: null,
        openWorkflowConfiguringDialog: false,
        openSenderSettingsModal: false,
        entityIDForDocTemp: '',
        tableData: [],
        mappingIndex: -1,
        workflow_configuration: [
          {
            selected_users: [
              {
                entity_id: '',
                name: '',
                user_type: '',
                contact_id: '',
                selected_config_doc_id: '',
                is_primary_user: false,
              },
            ],
            workflow_id: '',
            company_id: '',
            selected_entity: '',
            fieldsMappedData: {},
            is_saved_as_draft: false,
            is_Action_Triggered_User_As_Sender: false,
          },
        ],
      };
    },
    methods: {
      async openWorkflowConfiguration() {
        try {
          this.workflow_configuration = JSON.parse(
            JSON.stringify(this.localStep?.workflow_configuration || this.workflow_configuration)
          );
          this.loading = true;
          let entityId = this.currentEntity._id;
          let response = await postAPICall('GET', `/fetch-workflow/${entityId}`, {});
          this.workflowsConfigData = response.data;
          if (
            this.localStep?.workflow_configuration &&
            this.localStep.workflow_configuration.length > 0 &&
            this.localStep.workflow_configuration[0]?.workflow_id
          ) {
            this.selectedWorkflow = this.workflowsConfigData.find(
              (workflow) => workflow._id === this.localStep.workflow_configuration[0].workflow_id
            );
          }
          if (
            this.workflow_configuration &&
            this.workflow_configuration[0] &&
            !this.workflow_configuration[0].fieldsMappedData
          ) {
            this.$set(this.workflow_configuration[0], 'fieldsMappedData', {});
          }
          this.openWorkflowConfiguringDialog = true;
          this.entityIDForDocTemp = entityId;
          let users = [];
          if (this.selectedWorkflow && Array.isArray(this.selectedWorkflow.workflow_users)) {
            this.selectedWorkflow.workflow_users.forEach((user) => {
              const existingUser = this.workflow_configuration[0]?.selected_users?.find(
                (u) => u.contact_type === user.contact_type && user.type !== 'SENDER'
              );
              if (user.type !== 'SENDER') {
                users.push({
                  contact_type: user.entity_id || user.contact_type || user.contact_type?._id || '',
                  name: user.name || '',
                  user_type: user.user_type || '',
                  contact_id: existingUser?.contact_id || user.contact_id || '',
                  selected_config_doc_id: user.selected_config_doc_id || '',
                  is_primary_user: existingUser?.is_primary_user || false,
                  email: existingUser?.email || user.email || '',
                });
              }
            });
          }
          this.workflow_configuration[0].selected_users = users;
          this.workflow_configuration[0].selected_users.map((user) => {
            if (user.contact_type === entityId) {
              user.contact_id = `${entityId}#email#${entityId}`;
              user.email = `${entityId}#email#${entityId}`;
            }
          });
          this.workflow_configuration[0].company_id = this.getActiveWorkspace?.company_id;
          let wfFields;
          if (this.localStep?.workflow_configuration[0]?.workflow_id) {
            wfFields = await postAPICall(
              'GET',
              `/fetch-workflow-fields/${this.localStep?.workflow_configuration[0]?.workflow_id}`,
              {}
            );
          }
          this.workflowElements = wfFields.data;
          this.wfelements = this.workflowElements.flatMap((field) =>
            field.pages[0].fields.map((page) => ({
              ...page,
              doc_temp_id: field._id,
              doc_name: field.name,
            }))
          );
          if (!this.workflow_configuration[0]?.fieldsMappedData) {
            this.$set(this.workflow_configuration[0], 'fieldsMappedData', {});
          }
          this.loading = false;
        } catch (err) {
          this.loading = false;
        }
      },
      async handleWorkflowsChange(temp) {
        this.workflow_configuration[0].workflow_id = temp;
        this.selectedWorkflow = this.workflowsConfigData.find((workflow) => workflow._id === temp);
        let entityId = this.currentEntity._id;
        let users = [];
        if (this.selectedWorkflow && Array.isArray(this.selectedWorkflow.workflow_users)) {
          this.selectedWorkflow.workflow_users.forEach((user) => {
            const existingUser = this.workflow_configuration[0]?.selected_users?.find(
              (u) => u.contact_type === user.contact_type && user.type !== 'SENDER'
            );

            if (user.type !== 'SENDER') {
              users.push({
                contact_type: user.entity_id || user.contact_type || user.contact_type?._id || '',
                name: user.name || '',
                user_type: user.user_type || '',
                contact_id: existingUser?.contact_id || user.contact_id || '',
                selected_config_doc_id: user.selected_config_doc_id || '',
                is_primary_user: existingUser?.is_primary_user || false,
                email: existingUser?.email || user.email || '',
              });
            }
          });
        }
        this.workflow_configuration[0].selected_users = users;
        this.loading = false;
        this.workflow_configuration[0].selected_users.map((user) => {
          if (user.contact_type === entityId) {
            user.contact_id = `${entityId}#email#${entityId}`;
            user.email = `${entityId}#email#${entityId}`;
          }
        });
        let wfFields;
        let wfId = this.workflow_configuration[0]?.workflow_id || temp;
        if (wfId) {
          wfFields = await postAPICall('GET', `/fetch-workflow-fields/${wfId}`, {});
        }
        this.workflowElements = wfFields.data;
        this.wfelements = this.workflowElements.flatMap((field) =>
          field.pages[0].fields.map((page) => ({
            ...page,
            doc_temp_id: field._id,
          }))
        );
      },
      resetWorkflowConfigureDialog() {
        this.openWorkflowConfiguringDialog = false;
      },
      async fetchData() {
        this.loading = true;
        this.LoadingText = 'Fetching fields data...';
        try {
          const data = await this.getAllEntityFields(this.entityIDForDocTemp);
          this.tableData = data;
        } catch (error) {
          console.error('Error fetching data:', error);
        } finally {
          this.loading = false;
        }
      },
    },
  };
</script>
<style scoped>
  .action-config-item {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    font-family:
      'Inter',
      system-ui,
      -apple-system,
      BlinkMacSystemFont,
      'Segoe UI',
      Roboto,
      'Helvetica Neue',
      Arial,
      sans-serif;
    font-size: 13px;
  }

  .email-config-button {
    border-radius: 6px;
    font-weight: 500;
    font-size: 13px;
    padding: 6px 12px;
    display: inline-flex;
    align-items: center;
    gap: 4px;
  }

  .email-config-button i {
    color: #409eff;
    font-style: normal;
  }

  .custom-card {
    background-color: #f9fafb;
    padding: 0.75rem;
    border-radius: 8px;
    margin-bottom: 0.5rem;
  }

  .number-highlight {
    font-weight: 600;
    margin-right: 8px;
  }

  .dialog-component .el-dialog__header {
    font-weight: 600;
    font-size: 14px;
  }

  .dialog-component .el-dialog__body {
    padding: 1rem;
  }

  .dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 0.5rem;
    padding: 0.75rem 1rem;
  }

  .el-button {
    border-radius: 6px;
    font-weight: 500;
    font-size: 13px;
    padding: 4px 10px;
  }

  .el-button i {
    margin-right: 4px;
  }

  .el-select .el-input__inner {
    font-size: 13px;
    border-radius: 6px;
    padding: 0.35rem 0.75rem;
  }

  .el-option:hover {
    background-color: #eff6ff;
  }

  .el-table th {
    background-color: #f3f4f6;
    font-weight: 600;
    color: #111827;
    font-size: 12px;
  }

  .el-table .el-table__body tr:hover {
    background-color: #f3f4f6;
  }

  .checkbox-center-right {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .info-icon {
    font-size: 12px;
    color: #409eff;
    margin-left: 4px;
  }
</style>
